import styled from "@emotion/styled";

export const HighlightText = styled("span")`
  position: relative;

  &:after {
    content: "";
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
    left: 0;
    background: rgba(38, 198, 202, 0.12);
    animation-name: highlight;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-direction: alternate;
  }

  @keyframes highlight {
    0% {
      width: 0;
      opacity: 0;
    }

    50% {
      width: 100%;
      opacity: 1;
    }
  }
`;
